import Breadcrumb from './../components/BreadCrumb';
import HeadingDetailsSection from './../sections/HeadingDetailsSection';
import ServiceSection from './../sections/ServiceSections';

function ServicesScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Services'>
          <Breadcrumb screen='Services'/>
        </HeadingDetailsSection>
        <ServiceSection/>
    </>
  );
}

export default ServicesScreen;
